// @flow

import App from './App.jsx';
import _ from 'lodash';
import $ from 'jquery';

import {path_is_inside} from './utils.js';
import {same_user_id, user_is_changed} from './types.js';

import type {T_User, T_NextErrOk, T_ErrOk} from './types.js';



export function remote_save(app: App, user: T_User, create: boolean, next: T_NextErrOk): void {
  const params = $.param({
    other         : user.user_name,
    new_real_name : user.real_name,
    new_email     : user.email,
    new_pass      : user.pass,
    new_role      : user.role,
    new_true_dirs : user.true_dirs,
    new_black_dirs: user.black_dirs,
    create_user   : create ? 'yes' : 'no',
    session_id    : app.session()
  });
  
  fetch(`${app.remote}/modify-user/?${params}`).then(resp => resp.json()).then((result: T_ErrOk) => {
    next(result);
  });
}



export function save_my_account(app: App, user: T_User, next: T_NextErrOk): void {
  if (! same_user_id(app.state.user, user)) {
    next({error: 'Los datos no corresponden con mis credenciales.'});
  }
  else if (! user_is_changed(app.state.user, user)) {
    next({ok: 'No fue necesario actualizar la cuenta de usuario.'});
  }
  else {
    // NOTE: las cosas que ahora están prohibidas son las que no están dentro de alguno de los true_dirs actuales,
    // MÁS   las que quedaron dentro de alguno de los black_dirs actuales. Esas son las que tenemos que matar.
    // No podemos llegar y usar app.is_black.
    
    const now_is_black = path => (! _.some(user.true_dirs, dir => path_is_inside(path, dir))) || _.some(user.black_dirs, bdir => `${path}/` === bdir || path_is_inside(path, bdir));
    
    app.kill_these(_.keys(app.map_ui.map.Shp_List).filter(now_is_black), () => {
      app.setState({user}, () => {                                                 // primera etapa: actualizar el usuario.
        const filelist = app.get_filelist(_.cloneDeep(user.true_dirs));
        
        app.setState({filelist}, () => {                                           // segunda etapa: actualizar el filelist,
          if (app.tree != null) {                                                  // porque el comportamiento de
            const {tree} = app;                                                    // app.get_filelist y app.is_black
                                                                                   // acaba de cambiar
            tree.setState({filelist}, () => {
              tree.open_these(app.map_ui.map.things_loaded(), () => {
                if (app.toolbar != null) {
                  app.toolbar.center_culti(true, true);
                }
                
                remote_save(app, user, false, next);
              });
            });
          }
          else {
            remote_save(app, user, false, next);
          }
        });
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/save_my_account.js